(function initCollectionFacets() {
  const root = document.querySelector('[data-collection-facets]');
  if (!root) return;

  const sortSelect = root.querySelector('[data-collection-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  const sidebar = root.querySelector('[data-collection-sidebar]');
  const toggle = root.querySelector('[data-collection-filters-toggle]');
  const closeBtn = root.querySelector('[data-collection-filters-close]');
  const backdrop = root.querySelector('[data-collection-filters-backdrop]');

  function openFilters() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (backdrop) backdrop.removeAttribute('hidden');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (backdrop) backdrop.setAttribute('hidden', '');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (toggle) {
    toggle.addEventListener('click', () => {
      if (sidebar && sidebar.classList.contains('is-open')) {
        closeFilters();
      } else {
        openFilters();
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeFilters);
  if (backdrop) backdrop.addEventListener('click', closeFilters);

  const form = root.querySelector('[data-collection-filters-form]');
  if (form) {
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          form.requestSubmit();
        }
      });
    });
  }
})();
